import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { loadedGuard } from 'core';
import { CollectionsListPageComponent } from 'core'
import { HelloComponent} from './pages/hello/hello.component';
import { SplashComponent } from './pages/splash/splash.component';
import { TourComponent } from './pages/tour/tour.component';
import { ActiveTourComponent } from './pages/active-tour/active-tour.component';
import { MapComponent } from './pages/map/map.component';
import { SearchComponent } from './pages/search/search.component';
import { EventsComponent } from './pages/events/events.component';
import { EventComponent } from './pages/event/event.component';
import { ToursComponent } from './pages/tours/tours.component';
import { ArComponent } from './pages/ar/ar.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ItemComponent } from './pages/item/item.component';
import { ExhibitComponent } from './pages/exhibit/exhibit.component';
import { LoadingComponent } from './pages/loading/loading.component';
import { VideosComponent } from './pages/videos/videos.component';
import { InfoComponent } from './pages/info/info.component';
import { CollectionsItemsComponent } from './pages/collections-items/collections-items.component';
import { ArListComponent } from './pages/ar-list/ar-list.component';
import { ExhibitListComponent } from './pages/exhibit-list/exhibit-list.component';
import { PermissionsComponent } from './pages/permissions/permissions.component';
import { SiteSectionComponent } from './pages/site-section/site-section.component';
import { InfoListComponent } from './pages/info-list/info-list.component';

const routes: Routes = [
  { path: '', redirectTo: 'splash', pathMatch: 'full',
    data: {
      footer: {
        show: false
      },
      is_redirect: true
    }
  },
  {
    path: 'loading',
    component: LoadingComponent,
    data: {
      header: {
        show: false,
      },
      footer: {
        show: false
      },
      is_redirect: true,
      animation: 'enterLeavePage'
    },
  },
  {
    path: 'permissions',
    component: PermissionsComponent,
    data: {
      header: {
        show: false,
      },
      footer: {
        show: false,
      },
      is_redirect: true,
      animation: 'enterLeavePage',
    }
  },
  { path: 'home', component: HomeComponent,
    data: {
      footer: {
        show: true
      },
      animation: 'enterLeavePage'
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'splash',
    component: SplashComponent,
    data: {
      header: {
        show: false, 
      },
      footer: {
        show: false
      },
      is_redirect: true,
      animation: 'enterLeavePage'
    }
  },
  { path: 'item/:id', component: ItemComponent, data: {
    header: {
      show: true
    },
    footer: {
      show: true
    },  
    canActivate: [loadedGuard]
  }},
  {
    path: 'collections', component: CollectionsListPageComponent,
    data: {
      header: {
        show: true
      },
      footer: {
        show: true
      },
      state: 'collections',
      animation: 'enterLeavePage'
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'tours/:id',
    component: TourComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      },
      animation: 'enterLeavePage'

    },
    canActivate: [loadedGuard]
  },
  {
    path: 'tour/:id',
    component: ActiveTourComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      },
      animation: 'enterLeavePage'

    },  
    canActivate: [loadedGuard]
    
  },
  {
    path: 'tours',
    component: ToursComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'map',
    component: MapComponent,
    data: {
      header: {
        show: false,
      },
      footer: {
        show: true
      },
      animation: 'enterLeavePage'

    },
    canActivate: [loadedGuard]
  },
  {
    path: 'search',
    component: SearchComponent,
    data: {
      header: {
        show: false,
      },
      footer: {
        show: true
      },
      animation: 'enterLeavePage'

    },
    canActivate: [loadedGuard]
  },
  {
    path: 'events',
    component: EventsComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'event/:id',
    component: EventComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'ar',
    component: ArComponent,
    data: {
      header: {
        show: true
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: {
      header: {
        show: true
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'exhibit/:id', component: ExhibitComponent, data: {
      header: {
        show: true
      },
      footer: {
        show: true
      },
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'videos',
    component: VideosComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      },
      animation: 'enterLeavePage'
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'info/:id', component: InfoComponent, data: {
      header: {
        show: true
      },
      footer: {
        show: true
      },
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'collections/:id',
    component: CollectionsItemsComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'ars',
    component: ArListComponent,
    data: {
      header: {
        show: true
      },
      footer: {
        show: true
      }
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'exhibits', 
    component: ExhibitListComponent, 
    data: {
      header: {
        show: true
      },
      footer: {
        show: true
      },
    },
    canActivate: [loadedGuard]
  },
  {
    path: 'section/:id', component: SiteSectionComponent, data: {
      header: {
        show: true
      },
      footer: {
        show: true
      },
    },
    canActivate: [loadedGuard]
  },
  {
    path: "infos",
    component: InfoListComponent,
    data: {
      header: {
        show: true,
      },
      footer: {
        show: true
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
